export enum SimpleModal{
    DEFAULT = 0,
    CONFIRMAR = 1   
}